import { Suspense, useRef } from "react";
import Sphere from "./Sphere";
import Blob from "./Blob";
import { nanoid } from "nanoid";
import Floor from "./Floor";
export default function Blobs() {
  // [설정/블롭] 파티클 갯수
  const numParticles = 16;

  return (
    <Suspense fallback={null}>
      <Sphere />
      {[...Array(numParticles).keys()].map(() => (
        <Blob key={nanoid()} fresnel={true} />
      ))}
      <Floor />
    </Suspense>
  );
}
